var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E7E9EC",
    d: "M31.333 24.77H29.51a.618.618 0 0 1-.623-.623V22.3a1.26 1.26 0 0 0-1.26-1.235h-1.922c-.337 0-.649-.137-.886-.362l-.898-.898-3.968 3.968L31.632 35.45a1.869 1.869 0 0 0 1.622.524l1.772-.287c.686 0 1.248-.562 1.248-1.248v-4.716c0-.686-.562-1.248-1.248-1.248h-1.81a.618.618 0 0 1-.623-.624v-1.846a1.26 1.26 0 0 0-1.26-1.235Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D9E0E2",
    d: "m22.208 21.508-.44.441 11.468 11.47.441-.442-11.469-11.469Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BCF1FF",
    d: "M16.688 6.107 6.095 16.687a3.743 3.743 0 0 0 0 5.29l6.176 6.177a3.743 3.743 0 0 0 5.29 0L28.154 17.56a3.743 3.743 0 0 0 0-5.29l-6.176-6.176a3.743 3.743 0 0 0-5.29 0v.012Zm1.098 6.838-4.854 4.853a1.559 1.559 0 0 1-2.208 0 1.559 1.559 0 0 1 0-2.208l4.853-4.854a1.559 1.559 0 0 1 2.209 0 1.559 1.559 0 0 1 0 2.209Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#29D1FF",
    d: "M15.688 5.107 5.095 15.687a3.743 3.743 0 0 0 0 5.29l6.176 6.177a3.743 3.743 0 0 0 5.29 0L27.154 16.56a3.743 3.743 0 0 0 0-5.29l-6.176-6.176a3.743 3.743 0 0 0-5.29 0v.012Zm1.098 6.838-4.854 4.853a1.559 1.559 0 0 1-2.208 0 1.559 1.559 0 0 1 0-2.208l4.853-4.854a1.559 1.559 0 0 1 2.209 0 1.559 1.559 0 0 1 0 2.209Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValet);
export default __webpack_public_path__ + "static/media/Valet.cb82fbd3ed4192a8226f18faa145042c.svg";
export { ForwardRef as ReactComponent };